import React, { useEffect } from 'react'
import ListPosts from '../Utils/ListPosts'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { useParams } from 'react-router-dom'
import { getAllPostsOfGroupAPI, getAllPostsOfGroupInfo, getAllPostsOfGroupNextAPI, getHasNextGroupPosts, getHasNextUntilGroupPosts } from '../../RTK/Slice/Groups/GroupSlice'

const GroupPostsComponent = () => {

  // For Access User Token
  const activeToken = useSelector(getActiveToken) ;

  // For Get Token
  const token = useSelector(getToken) ;


  // For Disptach Action
  const disptach = useDispatch() ;
  
  // For Access Params
  const {groupId} = useParams() ; 
  console.log(groupId)

  // For Get All Posts Of Specific Group
  useEffect(()=>{
    disptach(getAllPostsOfGroupAPI({token , userToken : activeToken , groupId}));
  } , [])

  // For Access Next Post on group
  const hasNext = useSelector(getHasNextGroupPosts) ;

  const until = useSelector(getHasNextUntilGroupPosts) ;



  // For Access All Posts Of Group
  const {postsOfGroupStatus , postsOfGroupData} = useSelector(getAllPostsOfGroupInfo);

  // For Get The Next Post On Group Handler
  const getNextPostsOfGroupHandler = ()=>{
    disptach(getAllPostsOfGroupNextAPI({token , until , userToken : activeToken , groupId , hasNext} ))
  }


  return (
    <div className='all-post-page'>
        <ListPosts until={until} hasNextHandler={getNextPostsOfGroupHandler} hasNext={hasNext}  posts={postsOfGroupData} status={postsOfGroupStatus} />
    </div>
  )
}

export default GroupPostsComponent
